import React, { Component } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import { CpapTable } from "./CpapUtils";
import { AuthContext } from "../../../context/AuthContext";
import { db } from "../../../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

class CpapList extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      textSearch: "",
      sortBy: "Type",
      statusBy: "ทั้งหมด",
      activityBy: "ทั้งหมด",
      responsibleBy: "ทั้งหมด",
      availabilityBrand: "",
      availabilityModel: "",
      responsibleSelect: ["ทั้งหมด", "Center"],
    };
  }

  async componentDidMount() {
    try {
      const salesQuery = query(
        collection(db, "sales"),
        where("status", "==", "Available"),
      );
      const salesSnapshot = await getDocs(salesQuery);
      const salesList = salesSnapshot.docs.map((doc) => doc.data().name.trim());
      this.setState({
        responsibleSelect: Array.from(new Set(["ทั้งหมด", "Center", ...salesList])),
      });
    } catch (error) {
      console.error("Error loading sales representatives:", error);
    }
  }

  onClick = (e) => {
    e.preventDefault();
    console.log("onclick..");
  };

  onSearchChange = (e) => {
    setTimeout(() => {
      this.setState({ textSearch: e.target.value });
    }, 800);
  };

  onFilterChange = (option) => {
    this.setState({ sortBy: `${option}` });
  };

  onStatusChange = (option) => {
    this.setState({ statusBy: `${option}` });
  };

  onActivityChange = (option) => {
    this.setState({ activityBy: `${option}` });
  };

  onResponsibleChange = (option) => {
    this.setState({ responsibleBy: `${option}` });
  };

  onAvailabilityChange = (brand, model) => {
    this.setState((previous) => ({
      availabilityBrand: brand,
      availabilityModel: model,
      statusBy: brand || model
        ? (previous.availabilityBrand || previous.availabilityModel ? previous.statusBy : "ว่าง")
        : "ทั้งหมด",
    }));
  };

  render() {
    // var FilterOption = "Type" ;

    // this.state.sortBy = FilterOption ;

    return (
      <React.Fragment>
        {this.context.currentUser &&
          ["super_admin", "sale", "accountant"].includes(
            this.context.currentUser.roles[0],
          ) && (
            <>
              <PageTitle
                activeMenu="Search CPAP"
                motherMenu="CPAP"
                motherLink="/cpap-list"
              />
              <div className="form-head d-flex mb-3 mb-lg-5 align-items-start">
                <Link to="/cpap-register" className="btn btn-danger">
                  + New CPAP
                </Link>
                <div className="input-group search-area ml-auto d-inline-flex">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search here"
                    onChange={this.onSearchChange}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text c-pointer">
                      <i className="flaticon-381-search-2"></i>
                    </span>
                  </div>
                </div>
                <Dropdown
                  className="ml-1 width200"
                  onSelect={this.onFilterChange}
                >
                  <Dropdown.Toggle
                    variant="outline-primary"
                    id="dropdown-basic"
                  >
                    <i className="flaticon-381-controls-3 "></i> by{" "}
                    {this.state.sortBy == "LastDueDate"
                      ? "Due Date"
                      : this.state.sortBy}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu-right">
                    <Dropdown.Item href="#" eventKey={"Type"}>
                      Type
                    </Dropdown.Item>
                    <Dropdown.Item href="#" eventKey={"Brand"}>
                      Brand
                    </Dropdown.Item>
                    <Dropdown.Item href="#" eventKey={"Model"}>
                      Model
                    </Dropdown.Item>
                    <Dropdown.Item href="#" eventKey={"LastDueDate"}>
                      Due Date
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown
                  className="ml-1 width200"
                  onSelect={this.onStatusChange}
                >
                  <Dropdown.Toggle
                    variant="outline-primary"
                    id="dropdown-basic"
                  >
                    <i className="flaticon-381-menu-1"></i> Status{" "}
                    {this.state.statusBy}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="dropdown-menu-right">
                    <Dropdown.Item href="#" eventKey={"ทั้งหมด"}>
                      ทั้งหมด
                    </Dropdown.Item>
                    <Dropdown.Item href="#" eventKey={"ว่าง"}>
                      ว่าง
                    </Dropdown.Item>
                    <Dropdown.Item href="#" eventKey={"ไม่ว่าง"}>
                      ไม่ว่าง
                    </Dropdown.Item>
                    <Dropdown.Item href="#" eventKey={"ยกเลิกใช้งาน"}>
                      ยกเลิกใช้งาน
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <Dropdown
                  className="ml-1 width200"
                  onSelect={this.onActivityChange}
                >
                  <Dropdown.Toggle
                    variant="outline-primary"
                    id="dropdown-basic"
                  >
                    <i className="flaticon-381-menu-1"></i> Activity{" "}
                    {this.state.activityBy}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="dropdown-menu-right">
                    <Dropdown.Item href="#" eventKey={"ทั้งหมด"}>
                      ทั้งหมด
                    </Dropdown.Item>
                    {/* <Dropdown.Item href="#" eventKey={"จองเครื่อง"}>
                      จองเครื่อง
                    </Dropdown.Item>*/}
                    <Dropdown.Item href="#" eventKey={"ยืมเครื่อง"}>
                      ยืมเครื่อง
                    </Dropdown.Item>
                    <Dropdown.Item href="#" eventKey={"คืนเครื่อง"}>
                      คืนเครื่อง
                    </Dropdown.Item>
                    <Dropdown.Item href="#" eventKey={"ยกเลิกใช้งาน"}>
                      ยกเลิกใช้งาน
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <Dropdown
                  className="ml-3 width200"
                  onSelect={this.onResponsibleChange}
                >
                  <Dropdown.Toggle
                    variant="outline-primary"
                    id="dropdown-basic"
                  >
                    <i className="flaticon-381-user-8"></i>{" "}
                    {this.state.responsibleBy}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="dropdown-menu-right">
                    {this.state.responsibleSelect.map((name, index) => (
                      <Dropdown.Item key={index} href="#" eventKey={name}>
                        {name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <CpapTable
                text={this.state.textSearch}
                sortBy={this.state.sortBy}
                statusBy={this.state.statusBy}
                activityBy={this.state.activityBy}
                responsibleBy={this.state.responsibleBy}
                availabilityBrand={this.state.availabilityBrand}
                availabilityModel={this.state.availabilityModel}
                onAvailabilityChange={this.onAvailabilityChange}
                onStatusChange={this.onStatusChange}
              />
            </>
          )}
      </React.Fragment>
    );
  }
}

export default CpapList;
